import { Box, Button, Grid2, LinearProgress, Typography } from '@mui/material';
import { FC, MouseEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { useMuiTheme } from 'themes/themeMuiProvider';

import { FaCloud } from 'react-icons/fa6';

export const HashpowerMarketplaceCard: FC = () => {
  const muiTheme = useMuiTheme();
  const navigate = useNavigate();

  const handleClick = (e: MouseEvent<HTMLElement>) => {
    e.stopPropagation();
    navigate(`/cloud-miners/#2`);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        width: '100%',
        height: '100%',
        backgroundColor: 'white',
        borderRadius: '12px',
        flexDirection: 'column',
        p: 2,
        gap: '1.5rem',
        cursor: 'not-allowed',
        userSelect: 'none',
      }}
    >
      <Grid2 container direction='column' justifyContent='space-between' height='100%' spacing={2}>
        <Grid2 size={12}>
          <Box display='flex' color='text.disabled' alignItems='center' gap={1}>
            <FaCloud />
            <Typography variant='h6'>Hashpower Marketplace</Typography>
          </Box>
        </Grid2>

        <Grid2 size={12}>
          <Typography variant='body2' color='text.disabled'>
            0 running
          </Typography>
          <LinearProgress
            variant='determinate'
            value={0}
            sx={{
              height: 6,
              borderRadius: 1,
              backgroundColor: muiTheme.colors.grayLight2,
              '& .MuiLinearProgress-bar': {
                backgroundColor: muiTheme.colors.green,
              },
              mt: 1,
            }}
          />
        </Grid2>

        <Grid2 size={12}>
          <Box display='flex' justifyContent='flex-end' minHeight='40px'>
            <Button onClick={() => {}} variant='text' disabled>
              Coming soon
            </Button>
          </Box>
        </Grid2>
      </Grid2>
    </Box>
  );
};
